import { GQLDiffBlock } from "./types";

export const getHasMultipleDiffs = (diffBlocks: GQLDiffBlock[]) => {
  return diffBlocks.length > 1 || diffBlocks.some((diffBlock) => diffBlock.diffs.length > 1);
};
